import { IReferential } from '../interfaces/IReferential';
import { Organization } from '../interfaces/Organization';

/**
 * Generic, reusable grid column / sort / filter primitives — parameterized by the column-key
 * union so any screen can specialize them (e.g. `GridColumnFor<MyColumnKey>`).
 */

export enum ColumnType {
  Text = 'text',
  Select = 'select',
  Range = 'range',
  Date = 'date'
}

export interface RangeFilter {
  min: number | null;
  max: number | null;
}

/** A from/to date-interval filter (values are `yyyy-MM-dd` strings from a date input). */
export interface DateRangeFilter {
  from: string | null;
  to: string | null;
}

/** A select-filter value: plain string, numeric range, date interval, or a referential / organization object. */
export type ColumnFilter = string | RangeFilter | DateRangeFilter | IReferential | Organization;

export interface GridColumnFor<TKey extends string> {
  key: TKey;
  translationKey: string;
  label: string;
  className: string;
  type: ColumnType | null;
  numeric: boolean;
}

export type FiltersStateFor<TKey extends string> = { [key in TKey]?: ColumnFilter };

export interface SortStateFor<TKey extends string> {
  column: TKey | null;
  dir: 1 | -1;
}

export const isRangeFilter = (f: ColumnFilter): f is RangeFilter =>
  typeof f === 'object' && f !== null && ('min' in f || 'max' in f);

export const isDateRangeFilter = (f: ColumnFilter): f is DateRangeFilter =>
  typeof f === 'object' && f !== null && ('from' in f || 'to' in f);
